import ImagesSquareLight from '@/assets/imagesSquareLight.svg';
import { MediaGalleryContext, SystemFeaturesContext, Tooltip } from '@/components';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';

type GalleryButtonModel = {
  className?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

const GalleryButton = ({ className, tooltipPlacement = 'top' }: GalleryButtonModel) => {
  const t = useTranslations();
  const { mediaGallery: systemFeaturesMediaGallery } = useContext(SystemFeaturesContext);
  const mediaGalleryContext = useContext(MediaGalleryContext);

  if (!mediaGalleryContext.showGalleryButton) {
    return null;
  }

  return (
    <Tooltip
      placement={tooltipPlacement}
      backgroundColor={!systemFeaturesMediaGallery ? 'orange' : ''}
      content={systemFeaturesMediaGallery ? t('imageGallery.$openGallery') : t('membershipLevels.$featurenotavailable')}
    >
      <button
        className={classNames(
          'rounded-full p-2 hover:bg-gray-100',
          className,
          systemFeaturesMediaGallery ? 'cursor-pointer' : '!cursor-not-allowed opacity-50',
        )}
        onClick={() => mediaGalleryContext.openMediaGallery()}
      >
        <ImagesSquareLight className="fill-from-bg h-7 w-7" />
      </button>
    </Tooltip>
  );
};

export default GalleryButton;
